module.exports = __webpack_public_path__ + "static/media/General_settings_black.936a9471.svg";